export const sortedWeek = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
];

export const sortedWeekById = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
};

export const luxonWeekNumbers = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
];

export function weekdayIdToNumber(id: string) {
    for (let i = 0; i < luxonWeekNumbers.length; i++) {
        if (id === luxonWeekNumbers[i]) return i + 1;
    }

    return null;
}
